import { s as shams$1 } from '../has-symbols/shams.js';

var hasSymbols = shams$1;

var shams = function hasToStringTagShams() {
	return hasSymbols() && !!Symbol.toStringTag;
};

export { shams as s };
